export const GlobalVariables = {
    FILTER_SEARCH_DELAY: 2000,
    MAX_SKUS_PER_PRICE_REQUEST: 500,
    UPDATE_ACCESS_TOKEN_STATE_INTERVAL_MILLISECONDS: 10000,
    NO_SEARCH_RESULTS: "No results found",
    ZERO_SKUS: "No results found, please reset your filters",
    LOCAL_CURRENCY: "Local",
    DEFAULT_CURRENCY: "USD",
    ATTRIBUTES_NOT_ALLOWED: 'Attributes information is currently not available for inclusion in the excel download format. Please select CSV, to enable download of attribute information.',
    SKU_IMAGES_SMALL: 'Small/',
    SKU_IMAGES_ORIGINAL: 'Original/',
    PLACEHOLDER_45x65: '/assets/images/results-page/results-list/no-image-placeholder-45x65.svg',
    PLACEHOLDER_200x200: '/assets/images/sku-capsule/no-image-placeholder-200x200.svg'
};
